import { useEffect, useContext, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import Utils from "../../Utils";
import axios from "axios";
import _ from "lodash";
import { RecceTab } from "../../components/common";
import AttachmentDiscussion from "../../components/discussion/AttachmentDiscussion";
import FinalDocumentTab from "../../components/hotelRepresentative/FinalDocumentTab";
import Shotlists from "../../components/discussion/Shotlists";

const HrPhotoshootDetails = (props) => {
  const { id } = useParams();
  const fileInputRef = useRef(null);
  const [filter, setFilter] = useState({ pr_status: 0 }); // 0 = No Pr, 1 = PR Requested, 2 = PR Ready
  const [prReadyIds, setPrReadyIds] = useState([]);
  const [sendingPr, setSendingPr] = useState(false);

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  /* Photoshoot Images Listing */
  const [photoshootImages, setPhotoshootImages] = useState([]);
  const [photoshootFiles, setPhotoshootFiles] = useState([]);
  const updatePhotoshootImages = () => {
    axios
      .get(Utils.apiUrl(`photoshoot/photos?psid=${id}`), Utils.apiHeaders())
      .then((res) => {
        console.log(res.data);
        if (res.data.success) {
          setPhotoshootImages(res.data.data);
          console.log(_.groupBy(res.data.files, "photo_ids"));
          setPhotoshootFiles(_.groupBy(res.data.files, "photo_ids"));
        }
      })
      .catch((err) => {
        //callback(false, err.message);
      });
  };

  /* Getting status for number */
  const [status, setStatus] = useState([]);
  useEffect(() => {
    axios
      .get(Utils.apiUrl(`psstatus`), Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          setStatus(res.data.statuses);
        }
      })
      .catch((err) => {
        //callback(false, err.message);
      });
  }, []);

  /* Classes for specific status */
  const statusClasses = {
    Pending: "status-pill inline-block bg-pink-100 text-pink-700",
    Completed: "status-pill inline-block bg-green-200 text-green-700",
  };

  /* Hotel types */
  const hotel_types = {
    new: "New Property",
    converted: "Converted Property",
    established: "Established Property",
  };

  /* Recce Images Listing */
  const [recceImages, setRecceImages] = useState([]);
  const updateRecceImages = () => {
    axios
      .get(
        Utils.apiUrl(`photoshoot/recces/${id}?limit=9999`),
        Utils.apiHeaders(),
      )
      .then((res) => {
        console.log("Recce Images:");
        console.log(res.data);
        if (res.data.success) {
          setRecceImages(res.data.data);
        }
      })
      .catch((err) => {
        //callback(false, err.message);
      });
  };

  const [photoshootDetails, setPhotoshootDetails] = useState({});
  const fetchPhotoshootDetails = () => {
    axios
      .get(Utils.apiUrl(`photoshoot/${id}`), Utils.apiHeaders())
      .then((res) => {
        if (res.status == 200) {
          console.log("Photoshoot Details", res.data);
          setPhotoshootDetails(res.data);
          //updateRecceImages();
          updatePhotoshootImages();
        }
      })
      .catch((err) => {
        //callback(false, err.message);
      });
  };

  //const [hotelDetails, setHotelDetails] = useState([]);
  useEffect(() => {
    /* Getting Photoshoot Details */
    fetchPhotoshootDetails();
  }, []);

  const [activeTab, setActiveTab] = useState("details");
  const [activePsTab, setActivePsTab] = useState("approved");

  const canShotList = () => [1, 2].includes(photoshootDetails.status);

  const canSDeck = () => [3, 4].includes(photoshootDetails.status);

  const canPSRecceUpload = () => [5, 6].includes(photoshootDetails.status);

  const canUploadPhotos = () => [7, 8].includes(photoshootDetails.status);

  const psApproved = () => photoshootDetails.status >= 9;

  useEffect(() => {
    if (canShotList()) {
      setActiveTab("shotlist");
    } else if (canSDeck()) {
      setActiveTab("sdeck");
    } else if (canPSRecceUpload()) {
      setActiveTab("recce");
    } else if (canUploadPhotos()) {
      setActiveTab("photoshoot");
    } else if (psApproved()) {
      setActivePsTab("approved");
      setActiveTab("finaldocs");
    }
  }, [photoshootDetails]);

  const approvedImages = (pr_status) => {
    return photoshootImages.filter(
      (item) =>
        item.status === "bt-approved" &&
        (pr_status == 0 || item.pr_status === pr_status),
    );
  };

  const showStatuses = (photoshootDetails) => {
    let showStatuses = [1, 3, 5, 7, 9, 11];
    return (
      <div className="flex flex-col items-start space-y-2">
        {_.map(showStatuses, (s, idx) => (
          <div
            key={idx}
            className={`${statusClasses[s > photoshootDetails.status ? "Pending" : "Completed"]} inline w-full text-left`}
          >
            <i
              className={`fa-solid fa-${s <= photoshootDetails.status ? "check-circle" : "circle"}`}
            ></i>{" "}
            Status: {status[s]}
          </div>
        ))}
      </div>
    );
  };

  const renderMainTabs = () => {
    const status = photoshootDetails.status;
    const tabs = {
      shotlist: ["Shot-list", status >= 1],
      sdeck: ["Styling Deck", status >= 3],
      recce: ["Recce", status >= 5],
      photoshoot: ["Post Production Image Review", status >= 7],
      finaldocs: ["Download Final Images and Document", status >= 9],
    };
    return (
      <div className="flex space-x-2 border-b pb-3">
        {_.map(tabs, (tab, key) => (
          <button
            className={`tab-btn ${tab[1] && activeTab === key ? "active" : "bg-gray-100"} ${!tab[1] ? "cursor-not-allowed opacity-50" : ""}`}
            data-tab={key}
            onClick={() => (tab[1] ? setActiveTab(key) : null)}
          >
            {tab[0]}
          </button>
        ))}
      </div>
    );
  };

  const handlePrReadyChange = (photoId) => {
    setPrReadyIds((prev) => {
      if (prev.includes(photoId)) {
        return prev.filter((id) => id !== photoId);
      } else {
        return [...prev, photoId];
      }
    });
  };

  const sendPrReady = () => {
    if (prReadyIds.length === 0) {
      alert("Please select at least one image");
      return;
    }

    if (
      !window.confirm(
        "Are you sure you want to request PR for selected images?",
      )
    ) {
      return;
    }

    setSendingPr(true);

    axios
      .post(
        Utils.apiUrl("photoshoot/pr-request"),
        { photoIds: prReadyIds },
        Utils.apiHeaders(),
      )
      .then((res) => {
        if (res.data.success) {
          alert("PR requested successfully");
          setPrReadyIds([]);
          updatePhotoshootImages();
        } else {
          alert(res.data.message);
        }
      })
      .catch((err) => {
        console.error(err);
        alert("Error sending PR request");
      })
      .finally(() => {
        setSendingPr(false);
      });
  };

  return (
    <>
      <div className="container mx-auto p-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-8">
          Photoshoot Details
        </h1>
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex flex-col lg:flex-row lg:justify-between mb-6">
            <div className="text-left flex-1">
              <h2 className="text-2xl font-semibold mb-3">
                {photoshootDetails.title}
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-6 mb-4">
                {/* Left Column */}
                <div className="space-y-4">
                  <div className="grid grid-cols-2 gap-2">
                    <span className="text-sm text-gray-500">Type</span>
                    <span className="font-medium text-gray-800">
                      {hotel_types[photoshootDetails.hotel_type]}
                    </span>
                  </div>

                  <div className="grid grid-cols-2 gap-2">
                    <span className="text-sm text-gray-500">Photographer</span>
                    <span className="font-medium text-gray-800">
                      {photoshootDetails.pgname}
                    </span>
                  </div>

                  <div className="grid grid-cols-2 gap-2">
                    <span className="text-sm text-gray-500">
                      Hotel Photography Lead
                    </span>
                    <span className="font-medium text-gray-800">
                      {photoshootDetails.hrname}
                    </span>
                  </div>
                </div>

                {/* Right Column */}
                <div className="space-y-4">
                  <div className="grid grid-cols-2 gap-2">
                    <span className="text-sm text-gray-500">Shoot Date</span>
                    <span className="font-medium text-gray-800">
                      {formatDate(photoshootDetails.date_from)} -{" "}
                      {formatDate(photoshootDetails.date_to)}
                    </span>
                  </div>
                  <div className="grid grid-cols-2 gap-2">
                    <span className="text-sm text-gray-500">
                      Recce Completed By
                    </span>
                    <span className="font-medium text-gray-800">
                      {photoshootDetails.recce_end
                        ? formatDate(photoshootDetails.recce_end)
                        : "-"}
                    </span>
                  </div>

                  <div className="grid grid-cols-2 gap-2">
                    <span className="text-sm text-gray-500">
                      Completion Date
                    </span>
                    <span className="font-medium text-gray-800">
                      {photoshootDetails.delivery_date
                        ? formatDate(photoshootDetails.delivery_date)
                        : "-"}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="text-right">{showStatuses(photoshootDetails)}</div>
          </div>
          {/* <p className="text-sm text-gray-500 mt-1 text-right"><span className="font-medium text-gray-800">{photoshootDetails.status_label}</span></p> */}

          {/* <!-- Tabs --> */}
          <div className="mt-6">
            {renderMainTabs()}

            <div className="mt-6">
              {/* <!-- Tab: Photoshoot Details --> */}
              <div
                id="tab-shotlist"
                className={`tab-panel ${activeTab === "shotlist" ? "active" : "hidden"}`}
              >
                <Shotlists
                  attachments={photoshootDetails.attachments}
                  psId={id}
                  canUpload={canShotList}
                  onUpload={fetchPhotoshootDetails}
                />
              </div>

              {/* <!-- Tab: Photoshoot Styling Deck --> */}
              <div
                id="tab-sdeck"
                className={`tab-panel ${activeTab === "sdeck" ? "active" : "hidden"}`}
              >
                <RecceTab mode="sdeck" psId={id} canUpload={canSDeck} />
              </div>

              {/* <!-- Tab: Photoshoot Recce --> */}
              <div
                id="tab-recce"
                className={`tab-panel ${activeTab === "recce" ? "active" : "hidden"}`}
              >
                <RecceTab mode="recce" psId={id} canUpload={canPSRecceUpload} />
              </div>

              {/* <!-- Tab: Photoshoot Images --> */}
              <div
                id="tab-photoshoot"
                className={`tab-panel ${activeTab === "photoshoot" ? "active" : "hidden"}`}
              >
                <div className="mt-8">
                  {/* Sub Tabs */}
                  <div className="mb-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                      <div>
                        <div
                          className="flex space-x-2"
                          role="tablist"
                          aria-label="Files Tabs"
                        >
                          <button
                            className={`files-tab-btn px-4 py-2 rounded bg-gray-100 font-semibold ${filter.pr_status === 2 ? "active" : "bg-gray-100"}`}
                            onClick={() => setFilter({ pr_status: 2 })}
                          >
                            PR Requested{" "}
                            <span className="ml-2 text-sm text-gray-600">
                              ({approvedImages(2).length})
                            </span>
                          </button>
                          <button
                            className={`files-tab-btn px-4 py-2 rounded bg-gray-100 font-semibold ${filter.pr_status === 3 ? "active" : "bg-gray-100"}`}
                            onClick={() => setFilter({ pr_status: 3 })}
                          >
                            PR Ready{" "}
                            <span className="ml-2 text-sm text-gray-600">
                              ({approvedImages(3).length})
                            </span>
                          </button>
                          <button
                            className={`files-tab-btn px-4 py-2 rounded bg-gray-100 font-semibold ${filter.pr_status === 0 ? "active" : "bg-gray-100"}`}
                            onClick={() => setFilter({ pr_status: 0 })}
                          >
                            Approved Images{" "}
                            <span className="ml-2 text-sm text-gray-600">
                              ({approvedImages(0).length})
                            </span>
                          </button>
                        </div>
                      </div>
                      <div className="text-right text-sm">
                        <div className="block">
                          Initially Uploaded:{" "}
                          <span>{photoshootImages.length}</span>
                        </div>
                        <div className="block">
                          Revision Needed:{" "}
                          <span>
                            {
                              photoshootImages.filter((item) =>
                                ["ai-processed", "bt-rejected"].some((status) =>
                                  item.status.includes(status),
                                ),
                              ).length
                            }
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Approved Tab */}
                  {activePsTab === "approved" && (
                    <>
                      {filter.pr_status == 1 && (
                        <div className="rounded-md bg-yellow-100 px-4 py-3 text-sm text-yellow-700 mt-3">
                          <strong>Note:</strong> Photographer has been notified
                          about the PR requested, please wait for the
                          photographer to upload High-Res Zip and their Usage
                          Rights document.
                        </div>
                      )}

                      {/* <!-- Tiles will be appended here --> */}
                      {filter.pr_status === 1 &&
                        approvedImages(filter.pr_status).length > 0 && (
                          <div
                            id="file-grid"
                            className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-4 pt-2"
                          >
                            {approvedImages(filter.pr_status).map(
                              (item, index) => (
                                <>
                                  <div className="relative bg-white rounded-lg overflow-hidden shadow-sm border">
                                    <div className="h-40 bg-gray-100 flex items-center justify-center overflow-hidden">
                                      <img
                                        src={`${process.env.REACT_APP_API_URL}/photoshoot/photo/thumb/${item.fname}`}
                                        alt=""
                                        className="object-cover w-full h-full"
                                      />
                                    </div>
                                    <div className="p-3">
                                      <div
                                        className="text-sm font-semibold text-gray-800 truncate"
                                        title=""
                                      >
                                        Pic {index + 1}
                                      </div>
                                    </div>
                                  </div>
                                </>
                              ),
                            )}
                          </div>
                        )}
                      {filter.pr_status == 2 &&
                        _.keys(photoshootFiles).length > 0 &&
                        _.map(photoshootFiles, (psfiles, phids) => {
                          phids = phids.includes("[")
                            ? JSON.parse(phids)
                            : phids.split(",").map((id) => parseInt(id.trim()));
                          return (
                            <>
                              <div
                                id="file-grid"
                                className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-4 pt-2"
                              >
                                {approvedImages(filter.pr_status)
                                  .filter((item) =>
                                    phids.includes(parseInt(item.id)),
                                  )
                                  .map((item, index) => (
                                    <div
                                      className="relative bg-white rounded-lg overflow-hidden shadow-sm border"
                                      key={item.id}
                                    >
                                      <div className="h-40 bg-gray-100 flex items-center justify-center overflow-hidden">
                                        <img
                                          src={`${process.env.REACT_APP_API_URL}/photoshoot/photo/thumb/${item.fname}`}
                                          alt=""
                                          className="object-cover w-full h-full"
                                        />
                                      </div>
                                      <div className="p-3">
                                        <div
                                          className="text-sm font-semibold text-gray-800 truncate"
                                          title=""
                                        >
                                          Pic {index + 1}
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                              </div>

                              {filter.status === 3 &&
                                approvedImages(filter.pr_status).filter(
                                  (item) => phids.includes(parseInt(item.id)),
                                ).length > 0 &&
                                psfiles.map((file) => (
                                  <a
                                    href={file.filename}
                                    rel="noopener noreferrer"
                                    className="inline-flex items-center m-2 rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                  >
                                    <i className="fas fa-download"></i>
                                    <span>
                                      {file.filetype === 1
                                        ? "Usage Rights"
                                        : "High Res"}
                                    </span>
                                  </a>
                                ))}
                            </>
                          );
                        })}

                      {filter.pr_status === 0 &&
                        approvedImages(filter.pr_status).length > 0 && (
                          <>
                            <div
                              id="file-grid"
                              className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-4 pt-2"
                            >
                              {approvedImages(filter.pr_status).map(
                                (item, index) => (
                                  <div
                                    className="relative bg-white rounded-lg overflow-hidden shadow-sm border"
                                    key={item.id}
                                  >
                                    <div className="h-40 bg-gray-100 flex items-center justify-center overflow-hidden">
                                      <img
                                        src={`${process.env.REACT_APP_API_URL}/photoshoot/photo/thumb/${item.fname}`}
                                        alt=""
                                        className="object-cover w-full h-full"
                                      />
                                    </div>

                                    <div className="p-3">
                                      <div className="text-sm font-semibold text-gray-800 truncate">
                                        Pic {index + 1}
                                      </div>
                                    </div>

                                    {/* Request PR checkbox */}
                                    {parseInt(item.pr_status) === 0 && (
                                      <div className="p-3">
                                        <input
                                          type="checkbox"
                                          checked={prReadyIds.includes(item.id)}
                                          onChange={() =>
                                            handlePrReadyChange(item.id)
                                          }
                                        />
                                        <label className="ml-2">
                                          Request PR
                                        </label>
                                      </div>
                                    )}
                                  </div>
                                ),
                              )}
                            </div>

                            {prReadyIds.length > 0 && (
                              <div className="text-right mt-4">
                                <button
                                  onClick={sendPrReady}
                                  disabled={sendingPr}
                                  className={`btn text-white py-2 px-4 rounded ${sendingPr ? "opacity-50 cursor-not-allowed" : ""}`}
                                >
                                  {sendingPr ? "Sending..." : "Send PR"}
                                </button>
                              </div>
                            )}
                          </>
                        )}

                      {filter.pr_status == 3 &&
                        _.keys(photoshootFiles).length > 0 &&
                        _.map(photoshootFiles, (psfiles, phids) => {
                          phids = phids.includes("[")
                            ? JSON.parse(phids)
                            : phids.split(",").map((id) => parseInt(id.trim()));
                          return (
                            <>
                              <div
                                id="file-grid"
                                className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-4 pt-2"
                              >
                                {approvedImages(filter.pr_status)
                                  .filter((item) =>
                                    phids.includes(parseInt(item.id)),
                                  )
                                  .map((item, index) => (
                                    <div
                                      className="relative bg-white rounded-lg overflow-hidden shadow-sm border"
                                      key={item.id}
                                    >
                                      <div className="h-40 bg-gray-100 flex items-center justify-center overflow-hidden">
                                        <img
                                          src={`${process.env.REACT_APP_API_URL}/photoshoot/photo/thumb/${item.fname}`}
                                          alt=""
                                          className="object-cover w-full h-full"
                                        />
                                      </div>
                                      <div className="p-3">
                                        <div
                                          className="text-sm font-semibold text-gray-800 truncate"
                                          title=""
                                        >
                                          Pic {index + 1}
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                              </div>

                              {filter.pr_status == 3 &&
                                approvedImages(filter.pr_status).filter(
                                  (item) => phids.includes(parseInt(item.id)),
                                ).length > 0 &&
                                psfiles.map((file) => (
                                  <a
                                    href={file.filename}
                                    rel="noopener noreferrer"
                                    className="inline-flex items-center m-2 rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                  >
                                    <i className="fas fa-download"></i>
                                    <span>
                                      {file.filetype === 1
                                        ? "Usage Rights"
                                        : "High Res"}
                                    </span>
                                  </a>
                                ))}
                            </>
                          );
                        })}
                    </>
                  )}
                </div>
              </div>

              {/* <!-- Tab: Final Documents --> */}
              <div
                id="tab-finaldocs"
                className={`tab-panel ${activeTab === "finaldocs" ? "active" : "hidden"}`}
              >
                <FinalDocumentTab
                  photoshootDetails={photoshootDetails}
                  finalDocs={_.filter(
                    _.flattenDeep(_.values(photoshootFiles)),
                    (f) => !f.isPR,
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HrPhotoshootDetails;
